import { FC } from 'react';
import { Avatar } from 'antd';
import { TbCreditCard } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { centerComponentInMiddleofView } from '@/utilities';

const ViewNotAccessibleBasedOnRole: FC = (): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <div
            style={{
                width: 16 * 18,
                minHeight: '20rem',
                margin: '0 auto',
                ...centerComponentInMiddleofView,
            }}
        >
            <Avatar
                shape='square'
                size={16 * 2.5}
                icon={<TbCreditCard size={'75%'} style={{ color: token.colorTextSecondary }} />}
                style={{ border: `1px solid ${token.colorBorder}` }}
            />
            <div style={{ color: token.colorTextSecondary, margin: '0.5rem 0', marginTop: '0.75rem' }}>
                Billing Not Accessible
            </div>
            <div style={{ textAlign: 'center' }}>
                <small style={{ color: token.colorTextTertiary }}>
                    Only workspace owners & administrators can manage billing for workspaces.
                </small>
            </div>
        </div>
    );
};

export default ViewNotAccessibleBasedOnRole;
